module.exports = __webpack_public_path__ + "img/ring_y_s_null_1.d0cd37f9.png";